// initial state
const state = {
  brand: null,
  country: null,
  i18n: null,
  locale: null,
  type: null,
  cssBrand: null,
  language: null,
  platform: null,
  homeTitle: null,
  // endpoint: 'https://api.wia.prod.wpsandwatch.com',
  endpoint: process.env.WIA_BASE_BACKEND_PATH
  // settings: null
}

// mutations
const mutations = {
//  saveConfig (state, { brand, country, i18n, locale, settings }) {
  saveConfig (state, {brand, country, i18n, locale, type, cssBrand, language, platform, homeTitle}) {
    state.brand = brand
    state.country = country
    state.i18n = i18n.default
    state.locale = locale
    state.type = type
    state.cssBrand = cssBrand
    state.language = language
    state.platform = platform
    state.homeTitle = homeTitle
    // state.settings = settings;
  }
}

export default {
  state,
  mutations
}
